<template>
  <div v-if="storage">

    <div class="catalog-item-select__image" @click="showIconDialog = true">

      <md-button v-if="!selection" @click="showIconDialog = true" class="md-icon-button">
        <md-icon>add</md-icon>
      </md-button>

      <div v-if="selection" @click="showIconDialog = true">
        <md-icon  class="catalog-item-select__edit">edit</md-icon>
        <img :src="selection" alt="">
      </div>

    </div>

    <md-dialog :md-active.sync="showIconDialog" class="catalog-item-select catalog-item-create__modal">

      <md-dialog-content>

        <div v-if="types && !selectedType" class="catalog-item-select__content">
          <md-button @click="showIconDialog = false" class="md-icon-button catalog-item-select__button catalog-item-select__button--close">
            <md-icon>close</md-icon>
          </md-button>

          <!--<h3 class="catalog-item-create__title">Typ wählen</h3>-->

          <div class="catalog-item-select__item" v-for="(type, index) in sortedTypes" :key="index" @click="selectedType = type.name">
            <img :bind="type.name" :src="'https://firebasestorage.googleapis.com/v0/b/onme-c1a37.appspot.com/o/'+ type.path +'?alt=media'" alt="">
          </div>
        </div>

        <div v-if="colors && selectedType">
          <md-button @click="goBack()" class="md-icon-button catalog-item-select__button catalog-item-select__button--back">
            <md-icon>arrow_back</md-icon>
          </md-button>

          <md-button @click="showIconDialog = false" class="md-icon-button catalog-item-select__button catalog-item-select__button--close">
            <md-icon>close</md-icon>
          </md-button>

          <!--<h3 class="catalog-item-create__title">Farbe wählen</h3>-->

          <div class="catalog-item-select__item" v-for="color in colors" :key="color.name" @click="select(color.key, color.path)">
            <img :src="'https://firebasestorage.googleapis.com/v0/b/onme-c1a37.appspot.com/o/'+ color.path +'?alt=media'" alt="">
          </div>
        </div>

      </md-dialog-content>

    </md-dialog>
  </div>
</template>

<script>
    export default {
        name: "CatalogItemIconSelect",
        data() {
            return {
                showIconDialog: false,
                selection: null,
                storage: null,
                types: [],
                colors: [],
                selectedType: null
            }
        },
        mounted() {
            const firebase = window.firebase
            this.storage = firebase.storage().ref()
            this.getProductTypes()
            if(this.selected) {
                this.selection = this.selected
            }
        },
        props: {
            selected: {
                type: String,
                default: ''
            },
        },
        computed: {
            sortedTypes() {
                return this.types.reverse()
            }
        },
        watch: {
            selectedType: function() {
                if(this.selectedType) {

                    var listRef = this.storage.child('catalog_icons/' + this.selectedType);
                    listRef.listAll().then(function(res) {
                        res.items.forEach(function(itemRef) {
                            var object = {
                                name: itemRef.name,
                                path: encodeURIComponent(itemRef.fullPath)
                            }
                            if(!itemRef.fullPath.includes('_default')) {
                                this.colors.push(object)
                            }
                        }.bind(this));

                    }.bind(this)).catch(function(error) {
                        console.log(error)
                    });
                }
            }
        },
        methods: {
            getProductTypes() {
                var listRef = this.storage.child('catalog_icons');
                // Find all the prefixes and items.
                listRef.listAll().then(function(res) {
                    res.prefixes.forEach(function(folderRef) {
                        var object = {
                            name: folderRef.name,
                            path: encodeURIComponent(folderRef.fullPath + '/' + folderRef.name +'_default.png')
                        }
                        this.types.push(object)
                    }.bind(this));
                }.bind(this)).catch(function(error) {
                    console.log(error)
                });
            },
            goBack: function() {
                this.selectedType = false
                this.colors = []
            },
            select: function(key, path) {
                let url = 'https://firebasestorage.googleapis.com/v0/b/onme-c1a37.appspot.com/o/'+ path +'?alt=media';
                this.selection = url
                this.$emit('update:icon', url)
                this.showIconDialog = false
            }
        }
    }
</script>

<style scoped>
  .md-dialog {
    overflow-y: scroll;
  }
  .md-icon-button {
    position: absolute;
  }
</style>